// Currently shopify doesn't provide an object that gives us the current url
// or the current related collection, so we have to do this in js
const insertCollectionBreadcrumb = () => {
  const collections = JSON.parse(document.querySelector('.product').getAttribute('data-product-collections'))

  // Tests the path if the product page comes from a related collection, and
  // puts the collection and product handle in named groups
  const url = new URL(window.location.href)
  const path = url.pathname.match(/^(\/collections\/)(?<collection>.*)(\/products\/)(?<product>.*)$/)

  if (collections && collections.length && path) {
    const collection = collections.find(collection => collection.handle === path.groups.collection)

    if (collection) {
      const collectionUrl = `${url.origin}/collections/${path.groups.collection}`

      // Insert the collection breadcrumb after the Home breadcrumb
      document.querySelector('.breadcrumbs .breadcrumbs__crumb')
        .insertAdjacentHTML('afterend', `
          <span class="breadcrumbs__crumb">/</span>
          <a class="breadcrumbs__crumb" href="${collectionUrl}">${collection.title}</span>
      `)
    }
  }
}

const initImageSwipers = () => {
  class ImageZoom {
    constructor() {
      this.el = null
      this.image = null
      this.toggled = false
      this.onClick = this.onClick.bind(this)
      this.onMouseMove = this.onMouseMove.bind(this)
      this.onTouchMove = this.onTouchMove.bind(this)
    }

    init(el) {
      this.el = el
      this.image = this.el.querySelector('img')
      this.el.addEventListener('click', this.onClick)
    }

    onClick() {
      if (this.toggled) {
        this.toggled = false
        this.el.classList.remove('product__images-swiper__image-wrap--zoomed-in')
        this.image.style.removeProperty('transform')
        this.el.removeEventListener('mousemove', this.onMouseMove)
        this.el.removeEventListener('touchmove', this.onTouchMove)
      } else {
        this.toggled = true
        this.el.classList.add('product__images-swiper__image-wrap--zoomed-in')
        this.image.style.setProperty('transform', 'scale(1.5) translate(0px, 0px)')
        this.el.addEventListener('mousemove', this.onMouseMove)
        this.el.addEventListener('touchmove', this.onTouchMove)
      }
    }

    destroy() {
      this.el.removeEventListener('click', this.onClick)
    }

    onMouseMove(evt) {
      const offsetWidth = (this.el.offsetWidth / 2) - evt.offsetX
      const offsetHeight = (this.el.offsetHeight / 2) - evt.offsetY

      this.image.style.setProperty(
        'transform',
        `scale(1.5) translate(${offsetWidth}px, ${offsetHeight}px)`
      )
    }

    onTouchMove(evt) {
      if (evt.touches.length) {
        evt.preventDefault()

        const elDomRect = this.el.getBoundingClientRect()

        // Touch events don't have offsetX values, just positional coordinates
        // relative to the viewport. We have to get the coordinates ourselves
        // relative to the touched element.
        const touchOffsetX = evt.touches[0].clientX - elDomRect.x
        const touchOffsetY = evt.touches[0].clientY - elDomRect.y

        const offsetWidth = (elDomRect.width / 2) - touchOffsetX
        const offsetHeight = (elDomRect.height / 2) - touchOffsetY

        this.image.style.setProperty(
          'transform',
          `scale(1.5) translate(${offsetWidth}px, ${offsetHeight}px)`
        )
      }
    }
  }

  const imageZoom = new ImageZoom()
  const images = JSON.parse(document.querySelector('.product').getAttribute('data-product-images'))
  const selector = '.product__images-swiper'
  const config = {
    allowTouchMove: false,
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      renderBullet: (index, className) => {
        const imageUrl = `${images[index]}&width=60&height=60`
        return `<img src="${imageUrl}" class="${className}" />`
      },
    },
    on: {
      init: (swiper) => {
        imageZoom.init(swiper.slides[swiper.activeIndex].querySelector('.product__images-swiper__image-wrap'))
      },
      destroy: (swiper) => {
        imageZoom.destroy()
      },
      slideChange: (swiper) => {
        imageZoom.destroy()
        imageZoom.init(swiper.slides[swiper.activeIndex].querySelector('.product__images-swiper__image-wrap'))
      },
    }
  }

  let swiper = new Swiper(selector, config)

  const variantPicker = document.querySelector('.product variant-picker')

  if (variantPicker) {
    if (variantPicker.currentVariant) {
      swiper.slideTo(images.findIndex((image) => image.includes(new URL('https:' + variantPicker.currentVariant.featured_image.src).pathname)))
    }

    variantPicker.addEventListener('variantchange', () => {
      if (variantPicker.currentVariant.featured_image) {
        swiper.slideTo(images.findIndex((image) =>{ image.includes(new URL('https:' + variantPicker.currentVariant.featured_image.src).pathname)}))
      }
    })
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', evt => {
      if (evt.detail.sectionId === 'product') {
        swiper = new Swiper(selector, config)
      }
    })

    document.addEventListener('shopify:section:unload', evt => {
      if (evt.detail.sectionId === 'product') {
        swiper.destroy()
      }
    })
  }
}

const makeTableResponsive = table => {
  const allTrs = [...table.querySelectorAll('tr')]
  const thead = allTrs[0]
  const ths = [...thead.querySelectorAll('td')]
  const trs = allTrs.slice(1)

  if (!ths.length && !trs.length) return

  const thTexts = ths.map(th => th.textContent)
  thead.classList.add('thead')
  ths.map(th => th.classList.add('th'))

  trs.forEach(tr => {
    const tds = tr.querySelectorAll('td')

    if (!tds.length) return

    tds.forEach((td, i) => {
      td.setAttribute('data-header', thTexts[i] || '')
    })
  })
  table.classList.add('product-description__responsive-table')
}

const productDescription = document.querySelector('.product-description');
const tables = productDescription.querySelectorAll('table');

if (tables.length > 0) {
  tables.forEach(makeTableResponsive)
}

insertCollectionBreadcrumb()
initImageSwipers()
